<template>
  <v-card :disabled="loading" :loading="loading">
    <v-toolbar color="secondary" dark>
      <v-toolbar-title>{{ label }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <HandlingListPdf :handling="handling" />
      <v-switch
        v-model="list"
        label="List"
      ></v-switch>
    </v-toolbar>

    <v-simple-table v-if="list">
      <thead>
        <tr>
          <td style="width:10px"></td>
          <td>QUANTITY</td>
          <td>SST</td>
          <td>TYPE</td>
          <td>HEAD</td>
          <td>SHAFT</td>
          <td>GRIP</td>
          <td>ACTIONS</td>
        </tr>
      </thead>
      <tbody>
        <BuildClubRow v-for="item in items" :item="item" :handling="handling" :key="item.prescriptionRowId" @update="update" />
      </tbody>
    </v-simple-table>
    <v-data-iterator
      v-else
      :items="items"
      :items-per-page="1"
      :footer-props="{
        disableItemsPerPage:true,
        itemsPerPage:1
      }"
      row
      wrap
    >
      <template v-slot:item="props">
        <BuildClubCard :key="props.item.prescriptionRowId" :item="props.item" :handling="handling" @update="update" />
      </template>
    </v-data-iterator>
  </v-card>
</template>

<script>
import BuildClubRow from "./BuildClubRow.vue";
import BuildClubCard from "./BuildClubCard.vue";
import { mapGetters } from "vuex";
import HandlingListPdf from "./dialog/HandlingListPdf.vue";
export default {
  components: {
    BuildClubRow,
    BuildClubCard,
    HandlingListPdf
},
  props: {
    label: {
      type: String
    },
    items: {
      type: Array
    },
    handling:{
      type:Object
    }
  },
  data: function() {
    return {
      rowsPerPageItems: [1],
      pagination: {
        rowsPerPage: 1
      },
      list: true
    };
  },
  computed: {
    ...mapGetters('handling', { handlingLoading: 'loading' }),
    ...mapGetters('build', { buildLoading: 'loading' }),
    ...mapGetters('orders', { orderLoading: 'loading' }),
    loading () {
      return this.handlingLoading || this.buildLoading || this.orderLoading
    },
  },
  methods: {
    update() {
      this.$emit("update");
    }
  }
};
</script>

<style></style>
